import React from "react";
import TopIssuesDonutChart from "./TopIssuesDonutChart";
import AllIssueCategoryList from "./AllIssueCategoryList";


export const Categorychart = ({
         datas,
  PriorityValues,
  SttausValues,
  Client,
  date,
  range,
  Client_id
}) => {


  return (
    <div style={{ display: "flex", gap:"21px", flexDirection:"column" }}>
   
    <div style={{ display: "flex", gap:"21px" }}>
        <div style={{ flex: 1 }}>
        <TopIssuesDonutChart 
      datas={datas}
      PriorityValues={PriorityValues}
      SttausValues={SttausValues}
      Client={Client}
      range={range}
      date={date}
              Client_id={Client_id}

        />
      </div>

      <div style={{ flex: 1 }}>
        <AllIssueCategoryList 
      datas={datas}
      PriorityValues={PriorityValues}
      SttausValues={SttausValues}
      Client={Client}
      range={range}
      date={date}
      Client_id={Client_id}
        />
      </div>
</div>
    </div>
  );
};
